import { Component, Inject, Input, OnInit, PLATFORM_ID, ViewEncapsulation } from '@angular/core';
import { HelperService } from '../../../Services/helper.service';
import { New } from '../../../models/new';
import { TranslationService } from '../../../Services/translation.service';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-homeblog',
  templateUrl: './homeblog.component.html',
  styleUrls: ['./homeblog.component.css'],
  encapsulation: ViewEncapsulation.Emulated,
})
export class HomeblogComponent implements OnInit {
  @Input() news: New[];

  // Language
  city: String = '';
  word: any = {};
  language: string = '';
  afterPageLoaded = false;

  constructor(
    private helperService: HelperService,
    private translationService: TranslationService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.city = this.helperService.getCity();
    this.word = this.translationService.word;
    this.language = this.translationService.language;
  }

  toLatin(word: string): string {
    return word = this.helperService.toLatin(word);
  }

  ngOnInit(): void { }

  ngAfterViewInit(): void {
    if(isPlatformBrowser(this.platformId)){
      window.addEventListener('load', () => {
        this.afterPageLoaded = true;
      });
    }
  }
}
